import styled from 'styled-components';
import { devices, medias } from 'assets/styled/tokens';

export const FirstLineHomeWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  @media ${devices.screenWide} {
    justify-content: space-between;
  }
  @media screen and (max-width: ${medias.desktopMd}) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 27px;
  }
`;
export const Bg1080pContainer = styled.div`
  @media screen and (max-width: ${medias.tablet}) {
    display: none;
  }
  @media ${devices.screenWide} {
    position: fixed;
    right: 0;
    bottom: 0;
    display: flex;
  }
`;
